export default __webpack_public_path__ + "static/media/logo.63609e06.png";